import React, { useContext } from 'react';
import { Divider, Message, Icon, Segment, Image } from 'semantic-ui-react';
import NotifContext from '../../contexts/NotifContext';
import { Link } from "react-router-dom";
import Utility from '../../Utility';
import GlobalContext from '../../contexts/GlobalContext';
import imgMatt from './../../assets/matt.jpg';

/**
 * 
 * @param {mobile, setNotifVisibleState} props 
 */
function Notifications(props) {
  const [notifState] = useContext(NotifContext);
  const [globalContext] = useContext(GlobalContext);
  const getContent = () => {
    let content = [];
    if (notifState.notifs.length > 0) {
      content = notifState.notifs.map(notif => {
        return (
          <Segment.Group key={notif.id}>
            <Segment >
              <div style={{ alignItems: 'center' }} className="d-flex justify-content-between">
                <div className="w-25">
                  <Image src={imgMatt} />
                </div>
                <div className="ml-2 w-75 text-left">
                  <h5>{globalContext.translations.chat}</h5>
                  <p className="description-text">{globalContext.translations.commentNotification + 'n°' + notif.bookingFolderId}</p>
                  {/* <span>Message : </span><span className="description-text">{notif.message.length > 100 ? notif.message.substring(1, 100) + ' ...' : notif.message}</span> */}
                </div>
              </div>
            </Segment>
            <Segment style={{ padding: 8 }}>
              <div>
                <Link to={{
                  pathname: `${Utility.getUrlBaseName()}/bookings/${notif.bookingFolderId}`,
                  state: { folderId: notif.bookingFolderId, messageScroll: true }
                }}>
                  <div onClick={() => props.setNotifVisibleState(false)}>{globalContext.translations.readTheMessage}</div>
                </Link>
              </div>
            </Segment>
          </Segment.Group>

        )
      })
    } else {
      content = <Message content={globalContext.translations.emptyNotifications} />
    }

    return content;
  }

  return (
    <div className="p-5">
      <h3 className="text-left" ><Icon name={Utility.getIconPage('notif')} />{globalContext.translations.notifications}</h3>
      <Divider />
      <div>
        {getContent()}
      </div>
    </div>
  )
}

export default Notifications;